// extracted by mini-css-extract-plugin
export default {"NCards_container":"NCards_NCards_container__aHtyS","NCards_itemBox":"NCards_NCards_itemBox__pkUKG"};